/* Usa el total ya renderizado y los cambios reales del carrito. Sin sondeo. */
(function () {
  'use strict';
  if (window.__miCartProgress) return;
  window.__miCartProgress = true;
  var total = null;
  function pintar(evento) {
    var bar = document.querySelector('[data-mi-shipping-bar]');
    if (!bar) return;
    var dato = evento && evento.detail && evento.detail.totalPrice;
    if (typeof dato === 'number' && Number.isFinite(dato)) total = dato;
    if (total === null) total = Number(bar.dataset.total) || 0;
    var goal = Number(bar.dataset.goal);
    if (!(goal > 0)) return;
    var percent = Math.max(0, Math.min(total / goal * 100, 100));
    var fill = bar.querySelector('.progress-fill');
    var track = bar.querySelector('.progress-bar');
    var truck = bar.querySelector('.truck-icon');
    if (!fill || !track || !truck) return;
    fill.style.width = percent + '%';
    track.setAttribute('aria-valuenow', String(Math.round(percent)));
    truck.style.left = (percent / 100 * Math.max(0, track.clientWidth - truck.offsetWidth)) + 'px';
  }
  document.addEventListener('mi:cart:rendered', pintar);
  window.addEventListener('resize', pintar, { passive: true });
  window.addEventListener('pageshow', pintar);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pintar, { once: true });
  else pintar();
})();
